import { render, staticRenderFns } from "./CatchWord.vue?vue&type=template&id=3b4e2d8a&lang=pug&"
import script from "./CatchWord.vue?vue&type=script&lang=js&"
export * from "./CatchWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports